export default "__VITE_ASSET__D0IZYBuI__"